<template>
    <section class="section -accordion">

        <div class="container">
            <div class="section__container">
                <div class="accordion__description">
                    <h2 class="accordion__title">Our <em>Manufacturers</em> </h2>
                    <p class="accordion__copy">Click to open and view products.</p>

                    <button 
                        :class="`button accordion__toggle ${ allOpen ? '-closedAccordion': '-tertiary' }`"
                        @click="openAll"
                        type="button"
                        aria-label="Manufacturers list toggle"
                        :aria-pressed="`${ allOpen ? 'true': 'false' }`"
                    >
                        {{allOpen ? 'Close': 'Open' }} All</button>
                </div>
                
                <div class="accordion__container">
                    
                    <slot /> 
                    
                </div>
            </div>
        </div>

    </section>

</template>

<script>

export default {
    data: function() {
        return {
            allOpen: false,
        }
    },
    methods: {
        openAll() {
            //
            this.allOpen = !this.allOpen;

            // Make all accordions children isOpen property equal to allOpen
            this.$children.forEach(child => {
                child.isOpen = this.allOpen;
            })

        },
    }
}

</script>